import React, { useState, useEffect } from 'react'
import { Link } from "react-router-dom"
import axios from "axios"

const View = () => {
    const [data, setData] = useState([])

    useEffect(() => {
        getData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getData = async () => {
        const response = await axios.post('/api/profil/pejabat', {
            key: '',
            jml: 100
        })
        setData(response.data)
    }

    return (<>
        <div className="col-md-12">
            <h1 className='color-dark font-bold lh-125'>Profil Pejabat</h1>
            <h4 className="color-dark font-bold lh-125">Dinas Penanaman Modal dan Pelayanan Terpadu Satu Pintu Kota Bekasi adalah Instansi Pemerintah yang bertugas melaksanakan kebijakan dan koordinasi pelayanan di bidang penanaman modal sesuai dengan ketentuan peraturan perundang-undangan.</h4>
            
            {/* Tambahkan d-flex align-items-stretch supaya row card tingginya seragam */}
            <div className="row d-flex align-items-stretch">
                {data.map((val, index) => (
                    <div className="col-md-3 mb-4 d-flex" key={index}>
                        {/* Tambahkan h-100 dan flex-column agar card mengisi penuh tinggi kolom dan flex rapi */}
                        <div className="card h-100 w-100 d-flex flex-column wow materialUp animation-delay-5">
                            
                            {/* Wrapper Foto/Iframe dengan tinggi konsisten */}
                            <div className="position-relative overflow-hidden bg-light" style={{ height: "280px" }}>
                                {val.url ? (
                                    <img 
                                        src={val.url} 
                                        alt={val.nama}
                                        className="w-100 h-100" 
                                        style={{ objectFit: "cover", objectPosition: "top center" }} 
                                    />
                                ) : (
                                    <div className="d-flex align-items-center justify-content-center h-100 text-muted">
                                        No Image
                                    </div>
                                )}
                            </div>

                            {/* Card Body dibuat flex-grow-1 supaya menyesuaikan sisa ruang */}
                            <div className="card-body d-flex flex-column flex-grow-1">
                                <h4 className='panel-title font-bold mb-2'>{val.nama}</h4>
                                <p className="text-muted mb-0">{val.jabatan}</p>
                            </div>

                            <div className="card-footer text-center bg-white border-top-0 pb-3">
                                <Link to={'/tentang-dpmptsp/profil-pejabat/' + val.title} className="btn btn-raised btn-primary br-2 no-m w-100">Lihat</Link>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </>)
}

export default View